import React, { useEffect, useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import PrintIcon from "@material-ui/icons/Print";
import MailIcon from "@material-ui/icons/Mail";
import EmailIcon from "@material-ui/icons/Email";
import { makeStyles } from "@material-ui/core/styles";
import { contactEmail } from "../enums";
import {
  notifyAdmin,
  notifyCustomer,
  doPrint,
  getQRCode,
  getOrderNumber,
} from "../ajax";

const useStyles = makeStyles((theme) => ({
  tabs: {
    marginBottom: theme.spacing() * 3,
    marinTop: theme.spacing(),
  },
  link: {
    cursor: "pointer",
    color: "blue",
    textDecoration: "underline",
  },
  payPal: {
    marginTop: theme.spacing(),
  },
}));

export default ({ contact, total, getBlobUrl, close }) => {
  const classes = useStyles();
  const [itemId, setItemId] = useState(null);
  const [blobUrl, setBlobUrl] = useState("");
  const [blobKey, setBlobKey] = useState("");

  useEffect(() => {
    getOrderNumber().then((orderNumber) => {
      getBlobUrl().then(({ url, key }) => {
        setItemId(orderNumber);
        setBlobUrl(url);
        setBlobKey(key);
      });
    });
  }, [getBlobUrl]);

  useEffect(() => {
    if (blobUrl && blobKey && itemId) {
      if (window.location.hostname !== "localhost") {
        notifyAdmin(
          `New Submission from ${contact.firstName} ${contact.lastName} for gmsubs.com #${itemId}: ${blobUrl}\r\n\r\nCustomer paid on ${contact.paymentMethod} with user ${contact.paymentUser}`
        );
      }

      getQRCode(blobUrl).then((qrCode) => {
        notifyCustomer(blobKey, itemId, qrCode, total, contactEmail);
      });
    }
  }, [blobUrl, blobKey, itemId, total, contact]);

  if (!blobUrl || !blobKey) {
    return null;
  }

  return (
    <Dialog open={true} disableBackdropClick>
      <DialogTitle>Thank You</DialogTitle>
      <DialogContent>
        <List>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <EmailIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Check your email"
              secondary="We sent you a copy of your order details."
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <PrintIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <>
                  {/* eslint-disable-next-line */}
                  <a
                    className={classes.link}
                    onClick={() =>
                      itemId ? doPrint(contact, blobUrl, itemId) : null
                    }
                  >
                    Print
                  </a>{" "}
                  your packing slip
                </>
              }
              secondary="Be sure to include this in your shipment. We sent a copy to your email."
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <MailIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Ship your cards"
              secondary={
                <>
                  GMS
                  <br />
                  10 Crawfords Corner Road
                  <br />
                  PO Box 288
                  <br />
                  Holmdel, NJ 07733
                </>
              }
            />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={close}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
